module.exports = __webpack_public_path__ + "static/media/braven-health-logo.e5a89540.png";